module.exports = __webpack_public_path__ + "static/media/bars-solid-full.7498ecf8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bars-solid-full.svg
// module id = 227
// module chunks = 0